import { DIM2CLASS } from '../core/icon-class';

require('./sidebar.component.scss');

class SidebarController {
  constructor(
    $scope,
    CurrentFilterService,
    AggregateDataService,
    CurrentModelService,
    $rootScope,
    PermissionService,
    RouterService,
    FiltersService,
  ) {
    this.$scope = $scope;
    this.currentFilter = CurrentFilterService;
    this.filterBar = CurrentFilterService.filterBar;
    this.DIM2CLASS = DIM2CLASS;
    this.AggregateDataService = AggregateDataService;
    this.CurrentModelService = CurrentModelService;
    this.$rootScope = $rootScope;
    this.permission = PermissionService;
    this.router = RouterService;
    this.FiltersService = FiltersService;
  }

  get model() {
    return this.CurrentModelService.model;
  }

  get panel() {
    return this.currentFilter.panel;
  }

  set panel(panel) {
    this.currentFilter.panel = panel;
  }

  get filter() {
    return this.currentFilter.filter;
  }

  set filter(filter) {
    this.currentFilter.filter = filter;
  }

  get filters() {
    return this.FiltersService.filters;
  }

  viewReport() {
    this.router.panel = 'catalog';
    this.$rootScope.$broadcast('resize');
  }

  viewFilter() {
    this.router.panel = 'constructor';
    this.$rootScope.$broadcast('resize');
  }
}

export function SidebarComponent() {
  return {
    restrict    : 'E',
    template    : require('./sidebar.component.html'),
    scope       : true,
    controller  : SidebarController,
    controllerAs: '$ctrl',
  };
}



// WEBPACK FOOTER //
// ./src/layout/sidebar.component.js